import React from 'react';
import { ConversationCard } from './ConversationCard';

const ChatSidebar = ({ 
  conversations, 
  activeConversationId, 
  onSelectConversation, 
  onCreateNew, 
  loading 
}) => {
  if (loading) {
    return (
      <div className="w-full md:w-96 border-r border-gray-200 bg-white flex flex-col items-center justify-center p-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
        <p className="text-sm text-gray-500 mt-4 font-medium">Loading conversations...</p>
      </div>
    );
  }

  return (
    <div className={`w-full md:w-96 border-r border-gray-200 bg-white flex-col h-full z-10 shadow-sm relative ${activeConversationId ? 'hidden md:flex' : 'flex'}`}>
      <div className="p-5 border-b border-gray-100 bg-white flex justify-between items-center shadow-sm z-10">
        <div>
          <h2 className="text-xl font-bold text-gray-900 tracking-tight">Inbox</h2>
          <p className="text-xs text-gray-500 font-medium mt-0.5">{conversations.length} total conversations</p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto bg-gray-50/30">
        {conversations.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full p-8 text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <p className="text-gray-900 font-medium mb-1">No messages</p>
            <p className="text-gray-500 text-sm">When you receive a new message, it will appear here.</p>
          </div>
        ) : (
          conversations.map((conv) => (
            <ConversationCard 
              key={conv._id}
              conversation={conv}
              isActive={activeConversationId === conv._id}
              onClick={() => onSelectConversation(conv._id)}
            />
          ))
        )}
      </div>

      {/* Floating Action Button for New Conversation */}
      <button
        onClick={onCreateNew}
        className="absolute bottom-6 right-6 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center focus:outline-none focus:ring-4 focus:ring-green-500/30 active:scale-95"
        title="Start New Conversation"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
        </svg>
      </button>
    </div>
  );
};

export default ChatSidebar;
